import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";

interface ResourceLinkProps {
  value: string;
  url: string;
}

const ResourceLink = ({ value, url }: ResourceLinkProps) => {
  const theme = useTheme();
  return (
    <>
      {value ? (
        <Link
          to={`${url}`}
          style={{
            color: theme.tokens.FuelColorBrandPrimary,
          }}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`link-${value}`}
        >
          <Box sx={{ display: "flex" }}>
            {value}
            <OpenInNewIcon
              data-html2canvas-ignore="true"
              data-testid="open-in-new-tab-icon"
              fontSize="small"
              sx={{
                position: "relative",
                left: theme.tokens.FuelSpacing1,
              }}
            />
          </Box>
        </Link>
      ) : (
        ""
      )}
    </>
  );
};

export default ResourceLink;
